import React, { useState, FC, FocusEvent, ChangeEvent, useEffect } from 'react'

import { ValueFieldProps } from '@sitecore-jss/sitecore-jss-react-forms/types'
import { StringInputViewModel } from '@sitecore-jss/sitecore-jss-forms'

const PasswordField: FC<ValueFieldProps<StringInputViewModel>> = (props) => {
  const {
    field,
    value: _value,
    tracker,
    errors,
    isValid,
    fieldValidationErrorsComponent,
    onChange,
  } = props

  const [value, setValue] = useState(_value)
  const [hasFocus, setHasFocus] = useState(false)
  const [hasVisiblePassword, setHasVisiblePassword] = useState(false)

  const FieldValidationErrors = fieldValidationErrorsComponent

  const hasValueOrFocus = hasFocus || value !== ''
  const hasAnyError = !!errors?.length
  const id = field.valueField.id
  const label = field.model.title
  const name = field.valueField.name

  const onFocus = (e: FocusEvent<HTMLInputElement>) => {
    tracker.onFocusField(field, e.target.value)
    setHasFocus(true)
  }

  const onBlur = (e: FocusEvent<HTMLInputElement>) => {
    tracker.onBlurField(field, e.target.value)
    setHasFocus(false)
  }

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value)
    onChange(field.valueField.name, e.target.value, isValid, [])
  }

  useEffect(() => {
    if (typeof window !== 'undefined' && 'customElements' in window) {
      import('@patternfly/pfe-icon-onhighway/dist/pfe-icon.js');
    }
  }, []);

  return (
    <div
      className={`sitecore-jss-form__control sitecore-jss-form__control--text-box ${
        hasAnyError ? 'sitecore-jss-form__control--has-error' : ''
      }`}
    >
      <label
        htmlFor={id}
        className={`sitecore-jss-form__label ${
          hasValueOrFocus ? 'sitecore-jss-form__label--has-focus' : ''
        }`}
      >
        {label}
      </label> 
      <input
        id={id}
        name={name}
        className="sitecore-jss-form__field"
        type={`${hasVisiblePassword ? 'text' : 'password'}`}
        onFocus={onFocus}
        onBlur={onBlur}
        onChange={handleChange}
        value={_value}
      />

      <button
        type="button"
        className="sitecore-jss-form__toggle-password-visibility-btn"
        onClick={() => setHasVisiblePassword(!hasVisiblePassword)}
      >
        {hasVisiblePassword ? (
          <pfe-icon icon="cnh-eye-off-line" size="24"></pfe-icon>
        ) : (
          <pfe-icon icon="cnh-eye-line" size="24"></pfe-icon>
        )}
      </button>

      {FieldValidationErrors && <FieldValidationErrors {...props} />}
    </div>
  )
}

export default PasswordField
